import React from 'react'
import styled from 'styled-components'
import { ProfileClub } from '../../../../data/profile/data-types'
import ProfileClubCard from './profile-club'
import { up } from 'styled-breakpoints'

type SectionProps = {
  title: string
  clubs: ProfileClub[]
}

const Section: React.FunctionComponent<SectionProps> = ({ title, clubs }) => (
  <Container>
    <Title>{ title }</Title>
    <Clubs>
        { clubs.map(el => <ProfileClubCard key={el.id} club={el} />) }
    </Clubs>
  </Container>
)

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
`

const Title = styled.div`
    /* color: ${p => p.theme.colors.bg}; */
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
`

const Clubs = styled.div`
    display: flex;
    grid-template-rows: 1fr;
    grid-column-gap: 16px;
    width: 100%;

    // Hack so that circles are visible
    padding-top: 10px;
    margin-top: -10px;

    overflow-x: auto;

    ${up('tablet')} {
        grid-column-gap: 32px; 
    }
`

export default Section